import { render } from "./GridComponentForReqCat.vue?vue&type=template&id=3ac3aed2&scoped=true"
import script from "./GridComponentForReqCat.vue?vue&type=script&lang=js"
export * from "./GridComponentForReqCat.vue?vue&type=script&lang=js"

import "./GridComponentForReqCat.vue?vue&type=style&index=0&id=3ac3aed2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ac3aed2"]])

export default __exports__